<template>
  <div class="header">
    <a id="logo" href="javascript:void(0);" @click="handleSelect('https://www.gstarcad.net/Eshop','url',$event)">
      <img src="../../static/images/logo@2x.png" alt>
    </a>
    <ul class="header-menu">
      <li>
        <a href="javascript:void(0);" :class="currentIndex==='Home'?'active':''" @click="handleSelect('/','',$event)">Home</a>
      </li>
      <li>
        <div class="dropdown">
          <button
            class="btn btn-default dropdown-toggle"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            Products
            <span class="icon iconfont viewarrow-down"></span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
            <li>
              <a href="javascript:void(0);"  @click="handleSelect('http://view.cadwonder.net/','url',$event)">DWG FastView Plus</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="javascript:void(0);"  @click="handleSelect(threedUrl, 'url',$event)">3D FastView</a>
            </li>
          </ul>
        </div>
      </li>
      <li>
        <a href="javascript:void(0);" :class="currentIndex==='Contact Us'?'active':''" @click="handleSelect('/emailus','',$event)">Contact Us</a>
      </li>
      <li>
        <a href="javascript:void(0);" :class="currentIndex==='Shop'?'active':''" @click="handleSelect('/shop','',$event)">Shop</a>
      </li>
    </ul>

    <div class="dropdown-open-menu">
        <button
            class="btn btn-default dropdown-toggle"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span class="icon iconfont viewcaidan"></span>
          </button>
          <ul class="dropdown-menu  menu-right" aria-labelledby="dropdownMenu1">
            <li>
              <a href="javascript:void(0);" :class="currentIndex==='Home'?'active':''" @click="handleSelect('/','',$event)">Home</a>
            </li>
            <li>
              <a href="javascript:void(0);" :class="currentIndex==='DWG FastView Plus'?'active':''" @click="handleSelect('http://view.cadwonder.net/','url',$event)">DWG FastView Plus</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="javascript:void(0);" :class="currentIndex==='3D FastView'?'active':''" @click="handleSelect(threedUrl,'url',$event)">3D FastView</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="javascript:void(0);" :class="currentIndex==='Contact Us'?'active':''" @click="handleSelect('/emailus','',$event)">Contact Us</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="javascript:void(0);" :class="currentIndex==='Shop'?'active':''" @click="handleSelect('/shop','',$event)">Shop</a>
            </li>
          </ul>
    </div>
  </div>
</template>

<script>
import {baseUrl3D} from '../../config/build-config'
export default {
  data() {
    return {
      activeIndex: "1",
      currentIndex:'',
      threedUrl:baseUrl3D,
      btn:''
    };
  },
  methods: {
    handleSelect(path,type,event) {
      if(type==='url'){
        window.location.href = path
        return
      }
      this.$router.replace(path)
      // console.log(this.$route);
      // console.log('event')
      // console.log(event)
      this.currentIndex = event.srcElement.innerText
    },
    // clickBtn(event){
    //   console.log(event.target.style.color="rgba(255, 153, 0, 1)")
    // }
  }
};
</script>

<style lang="scss">
@import "../../static/css/header.scss";
</style>




// WEBPACK FOOTER //
// src/components/HeaderBar.vue